import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import { moveUserFunds, walletType } from "../../dashboard/DashboardUtils";
import { moveFundsSuccess } from "../../../redux/WalletSlice";
import { toast } from "react-toastify";
import { handleAdminUpdateRequest } from "../utils";
import { WalletContainer, WalletHeader } from "../../../auth/wallet/walletStyles";
import { Button, Typography, Box } from "@mui/material";
import PinComponent from "../../../auth/wallet/PinComponent";
import SuccessModal from "../../../components/SuccessModal";
import { onToggleFundFinanceReqModal } from "../ApprenticeshipSlice";
import Parse from "../../../api/ApiConfig";

const FundFinanceRequest = ({ fundRequestTab, setFundRequestTab, requestData }) => {
	const dispatch = useDispatch();
	const { adminWallet, moveFundsMessage } = useSelector((state) => state.wallet);

	const [loading, setLoading] = useState(false);
	const [updatedData, setUpdatedData] = useState(null);

	const mainWallet = adminWallet?.find((wallet) => wallet?.product === walletType.main);
	// console.log(mainWallet?.availableBalance, Number(requestData?.amount));
	const onCloseModal = () => {
		dispatch(onToggleFundFinanceReqModal(false));
	};

	// FUNCTION TO MOVE FUNDS TO LEASE INVESTMENT
	const moveFundsBetweenWallets = async () => {
		const details = {
			amount: String(requestData?.amountToRaise),
			source: "main",
			destination: walletType.financeInvestment,
			message: "finance-admin-fund-finance-request",
		};

		if (mainWallet?.availableBalance < Number(requestData?.amount)) {
			toast.error("Insuffient balance. Please fund your wallet!");
			return;
		}

		setLoading(true);
		try {
			const data = await moveUserFunds(details);
			dispatch(moveFundsSuccess(data));
			console.log(data);
		} catch (error) {
			toast.error(error);
		} finally {
			setLoading(false);
		}
	};

	// FUNCTION TO UPDATE REQUEST IN PARSE
	const onUpdateRequestInParse = async (id, data) => {
		setLoading(true);
		try {
			const res = await handleAdminUpdateRequest(id, data);
			setUpdatedData(res);
			console.log(res);
		} catch (error) {
			toast.error(error);
		} finally {
			setLoading(false);
		}
	};

	// ON PROCEED TO ACTIVE ASSETS
	const onFundRequestSuccess = () => {
		location.reload();
		setTimeout(() => {
			dispatch(onToggleFundFinanceReqModal(false));
		}, 500);
	};

	useEffect(() => {
		if (moveFundsMessage === "finance-admin-fund-finance-request") {
			const User = Parse.Object.extend("_User");
			const user = new User();
			user.id = Parse.User.current()?.id;

			const updatedData = {
				investors: ["Fortcore Admin"],
				investorsInfo: [
					{
						investorName: "Fortcore Admin",
						investorPhone: user?.get("phone"),
						investorEmail: user?.get("email"),
						investorId: Parse.User.current().id,
						investorAddress: user?.get("homeAddress"),
						amountPaid: requestData?.amountToRaise,
					},
				],
				funded: true,
			};
			onUpdateRequestInParse(requestData?.objectId, updatedData);
		} else {
			return;
		}
	}, [moveFundsMessage]);

	useEffect(() => {
		if (updatedData) {
			setFundRequestTab(3);
		} else {
			return;
		}
	}, [updatedData]);

	return (
		<>
			{fundRequestTab === 1 && (
				<WalletContainer>
					<>
						<WalletHeader
							headerText='Fund Finance Request'
							context='First Line Finance Admin Funds Finance Request on Approval.'
							onCloseModal={onCloseModal}
						/>
						<Typography marginY={2} color='black'>{`The amount of NGN ${Number(
							requestData?.amount
						).toLocaleString()} will be deducted from the admin wallet to fund this finance request.`}</Typography>
						<Box display='grid' gridTemplateColumns='1fr 1fr' gap={2}>
							<Button variant='outlined' color='error' onClick={onCloseModal}>
								cancel
							</Button>
							<Button variant='contained' color='primary' onClick={() => setFundRequestTab(2)}>
								proceed
							</Button>
						</Box>
					</>
				</WalletContainer>
			)}
			{fundRequestTab === 2 && (
				<PinComponent onClose={onCloseModal} onDeductFunds={moveFundsBetweenWallets} isLoading={loading} />
			)}
			{fundRequestTab === 3 && (
				<SuccessModal
					modalText={`The amount of N${Number(
						requestData?.amount
					).toLocaleString()} has been deducted from the admin wallet to fund this request.`}
					btnText='proceed'
					onReqClick={onFundRequestSuccess}
				/>
			)}
		</>
	);
};

FundFinanceRequest.propTypes = {
	fundRequestTab: PropTypes.number,
	setFundRequestTab: PropTypes.func,
	requestData: PropTypes.object,
};

export default FundFinanceRequest;
